<template>
  <generic-modal
    :title="$t('sociocultural representation')"
    :buttons="buttons"
    ref="generic_modal"
    size="fullscreen"
  >
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="general"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="info icon" aria-hidden="true"></i>
            <span>{{ $t("general") }}</span>
          </a>
        </li>
        <li data-tab="images" @click="change_active_tab($event, this)">
          <a>
            <i class="image icon" aria-hidden="true"></i>
            <span>{{ $t("images") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="general">
        <form v-if="meta.settings">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("site") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.site"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("latitude") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.latitude"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">{{ $t("longitude") }}</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    v-model="meta.settings.longitude"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('area')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/area/catalog"
                  name_field="name"
                  value_field="area_id"
                  @selected="set_area"
                  ref="area_dropdown"
                />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('subarea')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/subarea/catalog"
                  name_field="name"
                  value_field="subarea_id"
                  @selected="set_subarea"
                  ref="subarea_dropdown"
                />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('region')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/region/catalog"
                  name_field="name"
                  value_field="region_id"
                  @selected="set_region"
                  ref="region_dropdown"
                />
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("procedence") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.settings.procedence"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('temporality')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/temporality/catalog"
                  name_field="name"
                  value_field="temporality_id"
                  @selected="set_temporality"
                  ref="temporality_dropdown"
                />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('support')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/support/catalog"
                  name_field="name"
                  value_field="support_id"
                  @selected="set_support"
                  ref="support_dropdown"
                />
              </div>
            </div>
            <div class="column">
              <div class="field">
                <generic-dropdown
                  :title="$t('style')"
                  :placeholder="$t('select one')"
                  :is_multiple="false"
                  url="/museum/style/catalog"
                  name_field="name"
                  value_field="style_id"
                  @selected="set_style"
                  ref="style_dropdown"
                />
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ $t("description") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="meta.settings.description"
              ></textarea>
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t("iconographical analisys") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="meta.settings.iconographical_analisys"
              ></textarea>
            </div>
          </div>
        </form>
      </div>
      <div class="is-hidden" data-tab="images">
        <div class="field">
          <div class="control">
            <generic-uploader
              ref="generic_uploader"
              :idle_label="$t('drop representation images here')"
              endpoint_url="/museum/representation/image"
              :allow_multiple="true"
              @error="error_uploading"
              @success="success_uploading"
            />
          </div>
        </div>
        <div class="grid is-col-min-7">
          <div
            v-if="meta && meta.settings && meta.settings.images"
            class="cell"
            v-for="(photo, midx) in meta.settings.images"
            :key="midx"
          >
            <div class="card">
              <div class="card-image">
                <figure class="image is-128x128 m-auto py-3">
                  <v-lazy-image
                    :src="`${api_host}/drive/static/${photo.final_name}`"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="subtitle is-7 has-text-centered"></p>
                  </div>
                </div>
              </div>
              <footer class="card-footer">
                <div
                  class="button is-secondary card-footer-item"
                  @click="meta.settings.images.splice(midx, 1)"
                  :data-tooltip="$t('delete')"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                  <!-- <span>{{ $t("delete") }}</span> -->
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "SocioculturalRepresentationModal",
  components: {
    GenericModal,
    GenericUploader,
    VLazyImage,
    GenericDropdown,
  },
  props: {
    // module_settings: {
    //   type: Object,
    //   required: true,
    // },
  },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(representation_uuid) {
      let v = this;
      v.set_initial_state();

      get("/museum/representation", { uuid: representation_uuid })
        .then((representation) => {
          v.meta = representation;

          if (representation.settings.area_id)
            v.$refs.area_dropdown.set_value(representation.settings.area_id);

          if (representation.settings.subarea_id)
            v.$refs.subarea_dropdown.set_value(
              representation.settings.subarea_id
            );
          if (representation.settings.region_id)
            v.$refs.region_dropdown.set_value(
              representation.settings.region_id
            );

          if (representation.settings.temporality_id)
            v.$refs.temporality_dropdown.set_value(
              representation.settings.temporality_id
            );
          if (representation.settings.support_id)
            v.$refs.support_dropdown.set_value(
              representation.settings.support_id
            );
          if (representation.settings.style_id)
            v.$refs.style_dropdown.set_value(representation.settings.style_id);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    save() {
      let v = this;
      v.meta.hall_uuid = v.$route.params.hall_uuid;
      if (!v.meta.uuid)
        put("/museum/representation", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/museum/representation", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: { attributes: [] },
      };
      v.error = "";
      v.$refs.generic_uploader.clear();
      v.$refs.area_dropdown.clear();
      v.$refs.subarea_dropdown.clear();
      v.$refs.region_dropdown.clear();
      v.$refs.temporality_dropdown.clear();
      v.$refs.support_dropdown.clear();
      v.$refs.style_dropdown.clear();
      // v.$refs.category_dropdown.clear();
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
        meta: rspnse.file.settings,
        original_name: rspnse.file.name,
      };
      if (v.meta.settings.images) {
        v.meta.settings.images.push(data);
      } else {
        v.meta.settings.images = [data];
      }
    },
    set_area(area) {
      let v = this;
      if (area) v.meta.settings.area_id = area.area_id;
    },
    set_subarea(subarea) {
      let v = this;
      if (subarea) v.meta.settings.subarea_id = subarea.subarea_id;
    },
    set_region(region) {
      let v = this;
      if (region) v.meta.settings.region_id = region.region_id;
    },
    set_temporality(temporality) {
      let v = this;
      if (temporality)
        v.meta.settings.temporality_id = temporality.temporality_id;
    },
    set_support(support) {
      let v = this;
      if (support) v.meta.settings.support_id = support.support_id;
    },
    set_style(style) {
      let v = this;
      if (style) v.meta.settings.style_id = style.style_id;
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
